// src/pages/PermissionsPage.jsx
import React from 'react';
import PermissionList from '../../components/permissions/PermissionsList';

const PermissionsPage = () => {
  return <PermissionList />;
};

export default PermissionsPage;